import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasErr: false, error: null, errInfo: null };
  }

  static getDerivedStateFromErrror() {
    return { hasErr: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error Boundary caught an error!", error, errorInfo);
    this.setState({ error: error, errInfo: errorInfo });
  }

  render() {
    if (this.state.hasErr) {
      return (
        <div>
          <h2>Something went wrong.</h2>
          {this.props.fallback || <p>Please try again later.</p>}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
